import { useRouteError } from 'react-router-dom';
import { RefreshCw } from 'lucide-react';

/**
 * Error component for handling chunk loading failures
 * This typically happens when a new deployment occurs while the user has the app open
 */
export function ChunkLoadError() {
  const error = useRouteError() as Error;

  // Check if this is a chunk loading error
  const isChunkError = error?.message?.includes('Failed to fetch dynamically imported module') ||
                       error?.message?.includes('error loading dynamically imported module') ||
                       error?.message?.includes('Importing a module script failed');

  const handleReload = () => {
    // Force a hard reload to get the latest assets
    window.location.reload();
  };

  if (isChunkError) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
        <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
          <div className="mb-6">
            <RefreshCw className="w-16 h-16 mx-auto text-blue-500" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-4">
            New Version Available
          </h1>
          <p className="text-gray-600 mb-6">
            The application has been updated. Please reload the page to get the latest version.
          </p>
          <button
            onClick={handleReload}
            className="w-full bg-blue-500 hover:bg-blue-600 text-white font-semibold py-3 px-6 rounded-lg transition-colors"
          >
            Reload Page
          </button>
        </div>
      </div>
    );
  }

  // Generic error fallback
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <h1 className="text-2xl font-bold text-gray-900 mb-4">
          Something went wrong
        </h1>
        <p className="text-gray-600 mb-6">
          {error?.message || 'An unexpected error occurred'}
        </p>
        <button
          onClick={handleReload}
          className="w-full bg-blue-500 hover:bg-blue-600 text-white font-semibold py-3 px-6 rounded-lg transition-colors"
        >
          Reload Page
        </button>
      </div>
    </div>
  );
}
